export const SERVER_DATE = 'YYYY-MM-DD'
export const ABBREVIATED_MONTH_WITH_YEAR = 'MMM YYYY'
